import React, { useEffect, useState } from "react";
import { MdPhone } from "react-icons/md";
import styled, { keyframes, css } from "styled-components";
// import QRCode from "../../assets/img/whatsapp-QR.png";
import Arrow from "../../assets/img/Hand-drawn-arrow.png";
// Horizontal QR img
import QR_H_Code from "../../assets/img/QR-HR.png";
// Vertical QR img
import QR_V_Code from "../../assets/img/QR-VR.png";
import { LuRefreshCw } from "react-icons/lu";
import FullButton from "../../components/Buttons/FullButton";
// firebase
import { messaging, onMessage } from "../../config/firebase.js";

function BookingAgent() {
  const [isFlipped, setIsFlipped] = useState(false);
  const [refreshRotating, setRefreshRotating] = useState(false);
  const [bookingLoading, setBookingLoading] = useState(false);
  const [showTranscript, setShowTranscript] = useState(false);
  const [showTranscriptInfo, setShowTranscriptInfo] = useState({});

  // const calendarUrl = `https://calendar.google.com/calendar/event?action=TEMPLATE&dates=${
  //   booking.startTimeISO
  // }/${booking.endTimeISO}&text=${encodeURIComponent(
  //   booking.title
  // )}&details=${encodeURIComponent(
  //   booking.details
  // )}&location=${encodeURIComponent(booking.location)}`;

  //   const confirmationText = `Thank you for booking with us, ${booking.customerName}! 🎉 \n\n
  // Your appointment has been successfully scheduled for ${booking.formattedDateTime}. \n\n
  // Your Booking Details:\n
  // Name: ${booking.customerName}\n
  // Email: ${booking.customerEmail}\n
  // Phone: ${booking.customerPhone}\n\n
  // If you have any questions or need to make changes, feel free to contact our support team at ${booking.supportContact}. We look forward to serving you!`;

  const confirmationText = `Thank you for booking with us, Rahul Solanki! 🎉 \n
Your appointment has been successfully scheduled for 18/04/2025 01:00PM. \n
Your Booking Details: \n\n
Name: Rahul Solanki \n\n
Email: rahul.solanki@conversantech.com \n\n
Phone: +91 8780563090 \n\n
If you have any questions or need to make changes, feel free to contact our support team at 9988776655. We look forward to serving you!`;

  const textLines = confirmationText.split("\n").map((line, index) => {
    // Check if line contains "Thank you" to apply special styling
    if (line.includes("Thank you")) {
      return (
        <strong key={index}>
          {line}
          <br />
        </strong>
      );
    }

    // Check if line contains booking details header
    if (line.includes("Your Booking Details:")) {
      return (
        <React.Fragment key={index}>
          <br />
          <br />
          <b>{line}</b>
          <br />
        </React.Fragment>
      );
    }

    // Check if line contains contact info
    if (line.includes("If you have any questions")) {
      return (
        <React.Fragment key={index}>
          <br />
          <em>{line}</em>
          <br />
        </React.Fragment>
      );
    }

    // Regular line
    return <React.Fragment key={index}>{line}</React.Fragment>;
  });

  const handleQRClick = () => {
    setIsFlipped(true);
    setBookingLoading(true);
  };

  const handleRefresh = () => {
    setRefreshRotating(true);
    setIsFlipped(false);
    setShowTranscript(false);
  };

  useEffect(() => {
    // Set up foreground message listener that works for multiple messages
    const unsubscribe = onMessage(messaging, (payload) => {
      let title = payload.notification.title;
      let body = payload.notification.body;

      if (title === "Wait") {
        setIsFlipped(true);
        setBookingLoading(true);
      }
      if (title === "Done") {
        let data = payload.data;
        setIsFlipped(true);
        setBookingLoading(false);
        setShowTranscriptInfo(data);
        setShowTranscript(true);
      }
    });

    // Clean up the subscription when component unmounts
    return () => {
      unsubscribe();
    };
  }, []);

  return (
    <>
      <ChatPreview>
        <ChatWindow>
          <ChatHeader>
            <BotInfo>
              <MdPhone fontSize={20} />
              <BotName>Booking Agent</BotName>
            </BotInfo>
            <RefreshIcon
              onClick={handleRefresh}
              rotating={refreshRotating}
              onAnimationEnd={() => setRefreshRotating(false)}
            >
              <LuRefreshCw fontSize={22} />
            </RefreshIcon>
          </ChatHeader>
          <FlipContainer>
            <FlipCard isFlipped={isFlipped}>
              <FrontSide>
                <picture>
                  {/* Show vertical image on screens 600px wide or less (mobile) */}
                  <source srcSet={QR_V_Code} media="(max-width: 600px)" />
                  {/* Default to horizontal image for larger screens */}
                  <img src={QR_H_Code} alt="QR Code" />
                </picture>
              </FrontSide>
              <BackSide>
                {showTranscript ? (
                  <TranscriptContainer>
                    <TranscriptText>
                      {/* {textLines} */}
                      <strong>
                        {`Thank you for booking with us,
                        ${showTranscriptInfo.name && showTranscriptInfo.name}`}
                      </strong>
                      <br />
                      <br />
                      {showTranscriptInfo.date && (
                        <>
                          {`Your appointment has been successfully scheduled for
                          ${showTranscriptInfo.date}.`}
                        </>
                      )}
                      <br />
                      <br />
                      <b>Your Booking Details:</b>
                      <br />
                      {showTranscriptInfo.name && (
                        <>{`Name: ${showTranscriptInfo.name}`}</>
                      )}
                      <br />
                      {showTranscriptInfo.email && (
                        <>{`Email: ${showTranscriptInfo.email}`}</>
                      )}
                      <br />
                      {showTranscriptInfo.phone && (
                        <>{`Phone: ${showTranscriptInfo.phone}`}</>
                      )}
                      <br />
                      <br />
                      <em>
                        If you have any questions or need to make changes, feel
                        free to contact our support team at 9988776655. We look
                        forward to serving you!;
                      </em>
                      <br />
                      <p>
                        <a
                          href="https://calendar.google.com/calendar/u/0/r"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Add to Google Calendar
                        </a>
                      </p>
                    </TranscriptText>
                  </TranscriptContainer>
                ) : bookingLoading ? (
                  <LoadingIndicator>
                    <LoadingText>Calling</LoadingText>
                    <LoadingDot delay="0s" />
                    <LoadingDot delay="0.2s" />
                    <LoadingDot delay="0.4s" />
                  </LoadingIndicator>
                ) : null}
              </BackSide>
            </FlipCard>
          </FlipContainer>
        </ChatWindow>
        {/* <div style={{ display: "flex", padding: "10px" }}>
          <FullButton
            title="Call"
            action={() => {
              handleQRClick();
              setShowTranscript(false);
            }}
          />
          <FullButton
            title="Done"
            action={() => {
              setIsFlipped(true);
              setBookingLoading(false);
              setShowTranscript(true);
            }}
          />
        </div> */}
      </ChatPreview>
    </>
  );
}

const ChatPreview = styled.div`
  flex: 1;
  min-width: 300px;
  max-width: 450px;
  max-height: 600px;
`;

const ChatWindow = styled.div`
  background-color: white;
  border-radius: 0.5rem;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1),
    0 2px 4px -1px rgba(0, 0, 0, 0.06);
  overflow: hidden;
`;

const ChatHeader = styled.div`
  background-color: #7620ff;
  color: white;
  padding: 1rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const BotInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
`;

const BotName = styled.span`
  font-size: 16px;
  font-weight: 600;
`;

// Keyframes for 360deg rotation
const rotate360 = keyframes`
  100% {
    transform: rotate(360deg);
  }
`;

const RefreshIcon = styled.div`
  width: 24px;
  height: 24px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;

  ${({ rotating }) =>
    rotating &&
    css`
      animation: ${rotate360} 1s linear;
    `}
`;

const FlipContainer = styled.div`
  perspective: 1000px;
  padding: 20px;
  display: flex;
  justify-content: center;
`;

const FlipCard = styled.div`
  position: relative;
  width: 350px;
  height: ${(props) => (props.isFlipped ? "400px" : "200px")};
  transition: transform 0.8s, height 0.8s;
  transform-style: preserve-3d;
  transform: ${(props) => (props.isFlipped ? "rotateY(180deg)" : "rotateY(0)")};

  @media (max-width: 960px) {
    width: 450px;
    height: ${(props) => (props.isFlipped ? "400px" : "200px")};
  }

  @media (max-width: 600px) {
    width: 250px;
    height: ${(props) => (props.isFlipped ? "380px" : "400px")};
  }
`;

const FrontSide = styled.div`
  position: absolute;
  width: 100%;
  height: 200px; /* Fixed height for front side */
  backface-visibility: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;

  img {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
  }

  @media (max-width: 600px) {
    height: 400px;
  }
`;

const BackSide = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  min-height: 200px;
  max-height: 600px;
  backface-visibility: hidden;
  transform: rotateY(180deg);
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
`;

const LoadingIndicator = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
`;

const LoadingText = styled.p`
  color: #7620ff;
  font-size: 24px;
`;

const LoadingDot = styled.div`
  width: 12px;
  height: 12px;
  background-color: #7620ff;
  border-radius: 50%;
  animation: bounce 1.4s infinite ease-in-out;
  animation-delay: ${(props) => props.delay};

  @keyframes bounce {
    0%,
    80%,
    100% {
      transform: scale(0);
    }
    40% {
      transform: scale(1);
    }
  }
`;

const QRCodeDiv = styled.div`
  background-image: url(${(props) => props.bg});
`;

const TranscriptContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start; /* Align items to the left */
  overflow-y: auto;
  max-height: 100%;
  border-radius: 8px;
`;

const TranscriptText = styled.div`
  color: #333;
  font-size: 14px; /* Smaller base font size for better fit */
  line-height: 1.6;
  text-align: left; /* Left-aligned text for better readability */
  width: 100%;
  word-wrap: break-word;

  /* Style for different parts of the message */
  & strong,
  & b {
    font-weight: 600;
    color: #000;
  }

  /* Style for the first line (thank you message) */
  & > *:first-child {
    font-size: 16px;
    font-weight: 500;
    color: #7620ff;
    margin-bottom: 10px;
  }

  /* Style for appointment details */
  & a {
    color: #7620ff;
    text-decoration: none;
    display: inline-block;
    margin-top: 12px;
    font-weight: 500;

    &:hover {
      text-decoration: underline;
    }
  }

  /* Add some spacing between paragraphs */
  & br + br {
    content: "";
    display: block;
    margin-top: 8px;
  }

  /* Responsive font sizing */
  @media (max-width: 600px) {
    font-size: 13px;

    & > *:first-child {
      font-size: 15px;
    }
  }
`;

export default BookingAgent;
